import React, { useRef, useState} from 'react';
import '../../App.css';
import './ContactUs.css';
//import emailjs from 'emailjs-com'
import Titleimage from '../Titleimage';
import Swal from 'sweetalert2'



export default function Contact() {
  const formRef = useRef(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const onSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);

    const formData = new FormData(event.target);

     
    
        formData.append("access_key", "e7ff0646-b402-4389-a532-a3ce2a008f4e");
    
      const object = Object.fromEntries(formData);
    const json = JSON.stringify(object);

    try {
      const res = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: json
      }).then((res) => res.json());

      if (res.success) {
        Swal.fire({
          title: "Enviado!",
          text: "Mensaje enviado exitosamente",
          icon: "success"
        });
        formRef.current.reset();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } else {
        Swal.fire({
          title: "Error",
          text: "Hubo un problema al enviar el mensaje.",
          icon: "error"
        });
      }
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: "No se pudo conectar con el servidor.",
        icon: "error"
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div>
      <Titleimage
        heading="Contacto"
        text="Nos encanta saber de ti y poderte ayudar en lo que necesites."
      />
      <div className="contact">
        <form onSubmit={onSubmit} ref={formRef} aria-label="Formulario de contacto">
          <div className="row pt-5 mx-auto">
            <div className="col-8 form-group mx-auto">
              <input
                type="text"
                className="form-control"
                placeholder="Nombre"
                name="name"
                required
              />
            </div>
            <div className="col-8 form-group pt-2 mx-auto">
              <input
                type="email"
                className="form-control"
                placeholder="Correo Electrónico"
                name="email"
                required
              />
            </div>
            <div className="col-8 form-group pt-2 mx-auto">
              <input
                type="text"
                className="form-control"
                placeholder="Asunto"
                name="subject"
                required
              />
            </div>
            <div className="col-8 form-group pt-2 mx-auto">
              <textarea
                className="form-control"
                cols="30"
                rows="8"
                placeholder="Mensaje"
                name="message"
                required
              ></textarea>
              <button
                type="submit"
                disabled={isSubmitting}
                className={`submit-btn ${isSubmitting ? 'disabled' : ''}`}
              >
                {isSubmitting ? 'Enviando…' : 'ENVIAR'}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
